import {
  Component,
  inject,
  input,
  InputSignal,
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {DatePipe} from '@angular/common';
import {PersonalData} from '../../store/portal/portal.model';
import {Constants} from '../../constants/constants';
import {PasteApostropheAfterEachThreeNumsPipe} from '../../pipes/paste-apostrophe-after-each-three-nums.pipe';

@Component({
  selector: 'app-analytics-header-info',
  imports: [PasteApostropheAfterEachThreeNumsPipe, DatePipe],
  templateUrl: './analytics-header-info.component.html',
  styleUrl: './analytics-header-info.component.scss',
})
export class AnalyticsHeaderInfoComponent {

  private readonly translateService: TranslateService = inject(TranslateService);

  public readonly pdfMode: InputSignal<boolean> = input<boolean>(false);

  public readonly iOsMode: InputSignal<boolean> = input<boolean>(false);

  public readonly personalData: InputSignal<PersonalData | undefined> = input<PersonalData>();

  public readonly labels: InputSignal<Record<string, string> | undefined> = input<Record<string, string>>();

  protected readonly Constants = Constants;

  getLabel(key: string): string {
    const labels = this.labels();
    return labels?.[key] ? this.translateService.instant(labels?.[key]) : '';
  }

}
